import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { User } from '../../features/users/models/user.model';
import { AppForm } from '../../features/apps/models/app.model';
import { TeamForm } from '../../features/teams/models/team.model';
import { ModalType } from '../enums/modal-type.enum';


type ModalConfigByType =
  | { type: ModalType.USER; data?: User | null }
  | { type: ModalType.TEAM; data?: TeamForm | null }
  | { type: ModalType.APP; data?: AppForm | null };

export type ModalConfig = ModalConfigByType;

@Injectable({
  providedIn: 'root',
})
export class ModalService {
  private openModalSource = new Subject<ModalConfig>();
  openModal$ = this.openModalSource.asObservable();

  private closeModalSource = new Subject<void>();
  closeModal$ = this.closeModalSource.asObservable();

  open(type: ModalType.USER, data?: User | null): void;
  open(type: ModalType.TEAM, data?: TeamForm | null): void;
  open(type: ModalType.APP, data?: AppForm | null): void;
  open(
    type: ModalType,
    data?: User | TeamForm | AppForm | null,
  ): void {
    const modalConfig = this.createModalConfig(type, data);
    this.openModalSource.next(modalConfig);
  }

  private createModalConfig(type: ModalType, data?: User | TeamForm | AppForm | null): ModalConfig {
    switch (type) {
      case ModalType.USER:
        return { type, data: data as User | null };
      case ModalType.TEAM:
        return { type, data: data as TeamForm | null };
      case ModalType.APP:
        return { type, data: data as AppForm | null };
      default:
        throw new Error(`Unsupported modal type: ${type}`);
    }
  }

  close() {
    this.closeModalSource.next();
  }
}
